<template>
  <v-container class="limited">
    <dados-beneficiario></dados-beneficiario>
    <grid-faturas></grid-faturas>
  </v-container>
</template>

<script>
import DadosBeneficiario from "@/components/BeneficiaryData";
import GridFaturas from "./grid";

export default {
  name: "Faturas",
  components: {
    DadosBeneficiario,
    GridFaturas
  }
};
</script>
